module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pre', [_vm._v(_vm._s(_vm.data.BCH.summary))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.data.BTC.summary))]), _vm._v(" "), _c('p', [_vm._v("\n    Mining profitability based on fees, exchange rate and mining difficulty.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-xl-7 col-lg-8 col-md-8"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', [_c('tr', {
    class: {
      'bgdarilead': _vm.leader == 'BTC'
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', 'last', true))
    }
  })]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', '6h'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', '1d'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', '7d'))
    }
  })]), _vm._v(" "), _c('tr', {
    class: {
      'bgdarilead': _vm.leader == 'BCH'
    }
  }, [_vm._m(2, false, false), _vm._v(" "), _c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', 'last', true))
    }
  })]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', '6h'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', '1d'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', '7d'))
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col col-xl-12 col-lg-12 col-md-12 col-sm-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('small', [(!_vm.empty_any) ? [_vm._v("\n              * Based on the last block and exchange rates " + _vm._s(_vm.money(_vm.data.BTC.averages.last.price))), _c('sup', [_vm._v("BTC")]), _vm._v("\n              " + _vm._s(_vm.money(_vm.data.BCH.averages.last.price))), _c('sup', [_vm._v("BCH")])] : [_vm._v("\n              * Empty BTC or BCH block found, skipping calculations.\n            ")]], 2)]), _vm._v(" "), _vm._m(3, false, false)])])]), _vm._v(" "), _c('dari'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "trfirst"
  }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("current*")]), _vm._v(" "), _c('th', [_vm._v("6h"), _c('sup', [_vm._v("avg")])]), _vm._v(" "), _c('th', [_vm._v("1d"), _c('sup', [_vm._v("avg")])]), _vm._v(" "), _c('th', [_vm._v("7d"), _c('sup', [_vm._v("avg")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("BTC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("BCH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('small')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Recent changes")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-lightbulb-o fac"
  }), _vm._v("\n        Only show past 30 days in charts. I will bring longer (and shorter) time ranges back at a later point in time. The B2X fork \"suspension\" made me spend a lot of development time in vain and I now need make some changes before I can put the new updates online. Stay tuned.\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-lightbulb-o fac"
  }), _vm._v("\n        Removed BCH difficulty retarget prediction ("), _c('a', {
    attrs: {
      "href": "https://www.bitcoinabc.org/november",
      "target": "_blank"
    }
  }, [_vm._v("info")]), _vm._v(")\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c404ab4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 556
// module chunks = 1